module.exports = __webpack_public_path__ + "static/media/vc_alt2.39e8588f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/vc_alt2.jpg
// module id = 469
// module chunks = 0